import { LitElement } from 'lit';
import { styles as sharedStyles } from '../styles/shared-styles';
import { appState } from '../lib/app_state.js';
import { ActiveRecord } from '../lib/active_record.js';

export class ApplicationElement extends LitElement {
  static watchedScopes = new Set();
  static styles = [sharedStyles];

  get state() {
    return appState.getState();
  }

  connectedCallback() {
    super.connectedCallback();
    appState.addEventListener('state-changed', this);
    ActiveRecord.eventTarget.addEventListener('model-event', this);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    appState.removeEventListener('state-changed', this);
    ActiveRecord.eventTarget.removeEventListener('model-event', this);
  }

  handleEvent(event) {
    switch (event.type) {
      case 'state-changed':
        this.onStateChange(event);
        break;
      case 'model-event':
        this.onModelUpdate(event);
        break;
    }
  }

  onModelUpdate(event) {
    // console.log(event);
    const watchedScopes = this.constructor.watchedScopes || new Set();

    if(watchedScopes.has(event.scope)) this.requestUpdate();
  }

  onStateChange() {
    throw new Error('onStateChange must be implemented');
  }
}
